import * as React from 'react';

export interface IOptionalLinkProps extends React.HTMLAttributes<HTMLSpanElement> {
  href?: string | null;
  target?: string | null;
}

export const OptionalLink: React.SFC<IOptionalLinkProps> = ({ children, href, target, ...props }) => {
  if (href) {
    return (
      // В тайпингах HTMLAnchorElement target?: string,
      // не сойдутся тайпинги, если передать просто target
      // потому что в нашем случае, сверху прилетает еще и null
      <a {...props} href={href} target={target || undefined}>
        {children}
      </a>
    );
  }

  return <span {...props}>{children}</span>;
};
